
(function(){
  const qs=(s,r=document)=>r.querySelector(s), qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));
  function money(cents){
    const fmt=(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:fmt}).format(cents/100); } catch(e){ return '$'+(cents/100).toFixed(2); }
  }
  function updateHeader(){ qsa('[data-ace-cart-count]').forEach(el=>{ fetch('/cart.js').then(r=>r.json()).then(c=>el.textContent=c.item_count).catch(()=>{}); }); }
  document.addEventListener('scroll',()=>{ qsa('.ace-header').forEach(h=>h.classList.toggle('scrolled', window.scrollY>20)); },{passive:true});
  document.addEventListener('click', function(e){
    const openMenu=e.target.closest('[data-ace-open-menu]'); if(openMenu){ e.preventDefault(); qs('#AceMobileMenu')?.classList.add('is-open'); document.body.style.overflow='hidden'; return; }
    const closeMenu=e.target.closest('[data-ace-close-menu]'); if(closeMenu || e.target.matches('.ace-mobile-overlay')){ e.preventDefault(); qs('#AceMobileMenu')?.classList.remove('is-open'); document.body.style.overflow=''; return; }
    const openCart=e.target.closest('[data-ace-open-cart], a[href="#cart"]'); if(openCart){ e.preventDefault(); openDrawer(); return; }
    const closeCart=e.target.closest('[data-ace-close-cart]'); if(closeCart || e.target.matches('.ace-cart-overlay')){ e.preventDefault(); closeDrawer(); return; }
    const qbtn=e.target.closest('[data-ace-change]'); if(qbtn){ e.preventDefault(); const line=qbtn.dataset.line; const input=qs('[data-ace-line="'+line+'"]'); const qty=Math.max(0, parseInt(input.value||'0',10)+(qbtn.dataset.aceChange==='plus'?1:-1)); changeLine(line,qty); return; }
    const remove=e.target.closest('[data-ace-remove]'); if(remove){ e.preventDefault(); changeLine(remove.dataset.line,0); return; }
  });
  document.addEventListener('submit', function(e){
    if(e.defaultPrevented) return;
    const form=e.target.closest('form[action*="/cart/add"]');
    if(!form || form.dataset.aceNative==='true') return;
    e.preventDefault();
    const btn=form.querySelector('[type="submit"]'); const old=btn?btn.textContent:''; if(btn){btn.disabled=true; btn.textContent='Adding...';}
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
      .then(r=>{ if(!r.ok) throw r; return r.json(); })
      .then(()=>{ refreshCart(true); })
      .catch(()=>{ alert('Could not add this item. Please check the selected variant.'); })
      .finally(()=>{ if(btn){btn.disabled=false; btn.textContent=old;} });
  });
  function openDrawer(){ refreshCart(false); qs('#AceCartDrawer')?.classList.add('is-open'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ qs('#AceCartDrawer')?.classList.remove('is-open'); if(!qs('#AceMobileMenu')?.classList.contains('is-open')) document.body.style.overflow=''; }
  function changeLine(line,qty){ fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:parseInt(line,10),quantity:qty})}).then(r=>r.json()).then(()=>refreshCart(false)); }
  function refreshCart(open){ fetch('/cart.js').then(r=>r.json()).then(cart=>{ renderCart(cart); updateHeader(); if(open) openDrawer(); }); }
  function renderCart(cart){
    const root=qs('#AceCartItems'), subtotal=qs('#AceCartSubtotal'); if(!root) return;
    if(subtotal) subtotal.textContent=money(cart.total_price);
    if(!cart.items.length){ root.innerHTML='<div class="ace-cart-empty"><div><h3>Your cart is empty.</h3><p>Start with ACED apparel, memberships or live competition products.</p></div></div>'; return; }
    root.innerHTML=cart.items.map((item,i)=>`<div class="ace-cart-item"><a href="${item.url}"><img src="${item.image||''}" alt="${escapeHtml(item.product_title)}"></a><div><p class="ace-cart-title">${escapeHtml(item.product_title)}</p>${item.variant_title?`<p class="ace-cart-variant">${escapeHtml(item.variant_title)}</p>`:''}<div class="ace-cart-row"><div class="ace-qty"><button data-ace-change="minus" data-line="${i+1}">−</button><input data-ace-line="${i+1}" value="${item.quantity}" readonly><button data-ace-change="plus" data-line="${i+1}">+</button></div><span>${money(item.final_line_price)}</span></div><button class="ace-remove" data-ace-remove data-line="${i+1}">Remove</button></div></div>`).join('');
  }
  function escapeHtml(str){ return String(str||'').replace(/[&<>'"]/g, c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }

  function initReveal(){
    const items=qsa('.reveal');
    if(!items.length) return;
    if(!('IntersectionObserver' in window)){ items.forEach(el=>el.classList.add('show')); return; }
    const io=new IntersectionObserver((entries)=>{ entries.forEach(entry=>{ if(entry.isIntersecting){ entry.target.classList.add('show'); io.unobserve(entry.target); } }); },{threshold:.14, rootMargin:'0px 0px -40px 0px'});
    items.forEach(el=>io.observe(el));
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initReveal); else initReveal();
  updateHeader();
})();


(function(){
  function qs(s,r=document){return r.querySelector(s)}
  function qsa(s,r=document){return Array.from(r.querySelectorAll(s))}
  function openCart(){ qs('#AceCartDrawer')?.classList.add('is-open'); document.body.style.overflow='hidden'; }
  document.addEventListener('click',function(e){
    const tab=e.target.closest('[data-ace-tab] summary');
    if(tab){
      const current=tab.parentElement, group=current.closest('.ace-tabs');
      if(group && !current.open){ qsa('details[open]',group).forEach(d=>{ if(d!==current) d.removeAttribute('open'); }); }
    }
    const pill=e.target.closest('[data-ace-leader-tabs] .pill');
    if(pill){
      e.preventDefault();
      const wrap=pill.closest('[data-ace-leader-tabs]');
      qsa('.pill',wrap).forEach(p=>p.classList.remove('active'));
      pill.classList.add('active');
      const card=pill.closest('.leaderboard-card');
      const label=card && card.querySelector('.eyebrow');
      if(label){ label.textContent = label.textContent.replace(/\s—\s(Open|Male|Female)$/,'') + ' — ' + pill.textContent.trim(); }
    }
  });
  document.addEventListener('submit',function(e){
    const form=e.target.closest('form[action*="/cart/add"], form[data-ace-product-form]');
    if(!form || form.dataset.aceNative==='true') return;
    e.preventDefault();
    const btn=form.querySelector('[type="submit"]');
    const old=btn ? btn.innerHTML : '';
    if(btn){ btn.disabled=true; btn.innerHTML='<span>Adding...</span>'; }
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
      .then(r=>{ if(!r.ok) throw r; return r.json(); })
      .then(()=>fetch('/cart.js'))
      .then(r=>r.json())
      .then(cart=>{
        qsa('[data-ace-cart-count]').forEach(el=>el.textContent=cart.item_count);
        function esc(str){return String(str||'').replace(/[&<>'\"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','\"':'&quot;'}[c]||c;});}
        function m(cents){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100);}catch(err){return '$'+(cents/100).toFixed(2)}}
        const subtotal=qs('#AceCartSubtotal');
        if(subtotal) subtotal.textContent=m(cart.total_price);
        const root=qs('#AceCartItems');
        if(root){
          if(!cart.items.length){ root.innerHTML='<div class="ace-cart-empty"><div><h3>Your cart is empty.</h3><p>Start with ACED apparel, memberships or live competition products.</p></div></div>'; }
          else { root.innerHTML=cart.items.map((item,i)=>'<div class="ace-cart-item"><a href="'+item.url+'"><img src="'+(item.image||'')+'" alt="'+esc(item.product_title)+'"></a><div><p class="ace-cart-title">'+esc(item.product_title)+'</p>'+(item.variant_title?'<p class="ace-cart-variant">'+esc(item.variant_title)+'</p>':'')+'<div class="ace-cart-row"><div class="ace-qty"><button data-ace-change="minus" data-line="'+(i+1)+'">−</button><input data-ace-line="'+(i+1)+'" value="'+item.quantity+'" readonly><button data-ace-change="plus" data-line="'+(i+1)+'">+</button></div><span>'+m(item.final_line_price)+'</span></div><button class="ace-remove" data-ace-remove data-line="'+(i+1)+'">Remove</button></div></div>').join(''); }
        }
        openCart();
      })
      .catch(()=>{ alert('Could not add this item. Please check the selected variant.'); })
      .finally(()=>{ if(btn){btn.disabled=false; btn.innerHTML=old;} });
  }, true);
})();


/* ===== ACE TARGETED PATCH V4 - requested fixes only ===== */
(function(){
  const qs=(s,r=document)=>r.querySelector(s);
  const qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));
  function money(cents){
    const fmt=(window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:fmt}).format(cents/100); } catch(e){ return '$'+(cents/100).toFixed(2); }
  }
  function esc(str){ return String(str||'').replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]||c;}); }
  function renderCart(cart){
    qsa('[data-ace-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const subtotal=qs('#AceCartSubtotal'); if(subtotal) subtotal.textContent=money(cart.total_price);
    const root=qs('#AceCartItems'); if(!root) return;
    if(!cart.items.length){ root.innerHTML='<div class="ace-cart-empty"><div><h3>Your cart is empty.</h3><p>Start with ACED apparel, memberships or live competition products.</p></div></div>'; return; }
    root.innerHTML=cart.items.map((item,i)=>'<div class="ace-cart-item"><a href="'+item.url+'"><img src="'+(item.image||'')+'" alt="'+esc(item.product_title)+'"></a><div><p class="ace-cart-title">'+esc(item.product_title)+'</p>'+(item.variant_title?'<p class="ace-cart-variant">'+esc(item.variant_title)+'</p>':'')+'<div class="ace-cart-row"><div class="ace-qty"><button data-ace-change="minus" data-line="'+(i+1)+'">−</button><input data-ace-line="'+(i+1)+'" value="'+item.quantity+'" readonly><button data-ace-change="plus" data-line="'+(i+1)+'">+</button></div><span>'+money(item.final_line_price)+'</span></div><button class="ace-remove" data-ace-remove data-line="'+(i+1)+'">Remove</button></div></div>').join('');
  }
  function openCart(){ const d=qs('#AceCartDrawer'); if(d){ d.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  document.addEventListener('click', function(e){
    const pill=e.target.closest('[data-ace-leader-button]');
    if(pill){
      e.preventDefault();
      const card=pill.closest('.leaderboard-card');
      const category=pill.getAttribute('data-ace-leader-button');
      qsa('[data-ace-leader-button]', card).forEach(btn=>btn.classList.toggle('active', btn===pill));
      qsa('[data-ace-leader-table]', card).forEach(table=>table.classList.toggle('is-active', table.getAttribute('data-ace-leader-table')===category));
      const label=qs('[data-ace-leader-label]', card);
      if(label){
        const base=label.textContent.replace(/\s—\s(Open|Male|Female)$/i,'');
        label.textContent=base+' — '+pill.textContent.trim();
      }
      return;
    }
    const quick=e.target.closest('.ace-quick-add');
    if(quick){
      const form=quick.closest('form');
      if(form && form.classList.contains('ace-quick-add-form')){
        e.preventDefault();
        e.stopPropagation();
        const old=quick.innerHTML;
        quick.disabled=true; quick.innerHTML='Adding...';
        fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
          .then(r=>{ if(!r.ok) throw r; return r.json(); })
          .then(()=>fetch('/cart.js'))
          .then(r=>r.json())
          .then(cart=>{ renderCart(cart); openCart(); })
          .catch(()=>alert('Could not add this product to cart.'))
          .finally(()=>{ quick.disabled=false; quick.innerHTML=old; });
      }
    }
  }, true);
})();


/* ===== ACE TARGETED PATCH V5 - only requested fixes ===== */
(function(){
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function money(cents){
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'AUD';
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}
  }
  function esc(str){return String(str||'').replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]||c})}
  function render(cart){
    qsa('[data-ace-cart-count]').forEach(function(el){el.textContent=cart.item_count});
    var subtotal=qs('#AceCartSubtotal'); if(subtotal) subtotal.textContent=money(cart.total_price);
    var root=qs('#AceCartItems'); if(!root) return;
    if(!cart.items || !cart.items.length){root.innerHTML='<div class="ace-cart-empty"><div><h3>Your cart is empty.</h3><p>Start with ACED apparel, memberships or live competition products.</p></div></div>'; return;}
    root.innerHTML=cart.items.map(function(item,i){
      return '<div class="ace-cart-item"><a href="'+item.url+'"><img src="'+(item.image||'')+'" alt="'+esc(item.product_title)+'"></a><div><p class="ace-cart-title">'+esc(item.product_title)+'</p>'+(item.variant_title?'<p class="ace-cart-variant">'+esc(item.variant_title)+'</p>':'')+'<div class="ace-cart-row"><div class="ace-qty"><button data-ace-change="minus" data-line="'+(i+1)+'">−</button><input data-ace-line="'+(i+1)+'" value="'+item.quantity+'" readonly><button data-ace-change="plus" data-line="'+(i+1)+'">+</button></div><span>'+money(item.final_line_price)+'</span></div><button class="ace-remove" data-ace-remove data-line="'+(i+1)+'">Remove</button></div></div>';
    }).join('');
  }
  function openCart(){var d=qs('#AceCartDrawer'); if(d){d.classList.add('is-open'); document.body.style.overflow='hidden';}}
  function addForm(form, button){
    if(!form || form.__aceAdding) return;
    var idInput=form.querySelector('[name="id"]');
    var variantId=(idInput && idInput.value) || (button && button.getAttribute('data-variant-id'));
    if(!variantId) return;
    if(idInput) idInput.value=variantId;
    form.__aceAdding=true;
    var old=button ? button.innerHTML : '';
    if(button){button.disabled=true;button.innerHTML='Adding...';}
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok) throw r; return r.json()})
      .then(function(){return fetch('/cart.js',{headers:{'Accept':'application/json'}})})
      .then(function(r){return r.json()})
      .then(function(cart){render(cart); openCart();})
      .catch(function(){alert('Could not add this product to cart.');})
      .finally(function(){form.__aceAdding=false;if(button){button.disabled=false;button.innerHTML=old;}});
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.ace-quick-add');
    if(!btn) return;
    var form=btn.closest('form');
    if(!form || !form.classList.contains('ace-quick-add-form')) return;
    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    addForm(form, btn);
  }, true);
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form.ace-quick-add-form');
    if(!form) return;
    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    addForm(form, form.querySelector('.ace-quick-add,[type="submit"]'));
  }, true);
})();

/* ===== ACE TARGETED PATCH V6 - direct collection quick add only ===== */
(function(){
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function money(cents){
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'AUD';
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}
  }
  function esc(str){return String(str||'').replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]||c})}
  function render(cart){
    qsa('[data-ace-cart-count]').forEach(function(el){el.textContent=cart.item_count});
    var subtotal=qs('#AceCartSubtotal'); if(subtotal) subtotal.textContent=money(cart.total_price);
    var root=qs('#AceCartItems'); if(!root) return;
    if(!cart.items || !cart.items.length){root.innerHTML='<div class="ace-cart-empty"><div><h3>Your cart is empty.</h3><p>Start with ACED apparel, memberships or live competition products.</p></div></div>'; return;}
    root.innerHTML=cart.items.map(function(item,i){
      return '<div class="ace-cart-item"><a href="'+item.url+'"><img src="'+(item.image||'')+'" alt="'+esc(item.product_title)+'"></a><div><p class="ace-cart-title">'+esc(item.product_title)+'</p>'+(item.variant_title?'<p class="ace-cart-variant">'+esc(item.variant_title)+'</p>':'')+'<div class="ace-cart-row"><div class="ace-qty"><button data-ace-change="minus" data-line="'+(i+1)+'">−</button><input data-ace-line="'+(i+1)+'" value="'+item.quantity+'" readonly><button data-ace-change="plus" data-line="'+(i+1)+'">+</button></div><span>'+money(item.final_line_price)+'</span></div><button class="ace-remove" data-ace-remove data-line="'+(i+1)+'">Remove</button></div></div>';
    }).join('');
  }
  function openCart(){var d=qs('#AceCartDrawer'); if(d){d.classList.add('is-open'); document.body.style.overflow='hidden';}}
  function addVariant(btn){
    if(!btn || btn.__aceBusy) return;
    var variantId=btn.getAttribute('data-variant-id');
    if(!variantId) return;
    btn.__aceBusy=true;
    var old=btn.innerHTML;
    btn.classList.add('is-adding');
    btn.disabled=true;
    btn.innerHTML='Adding...';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:Number(variantId),quantity:1})
    })
    .then(function(r){if(!r.ok){return r.json().catch(function(){return {description:'Could not add this product to cart.'}}).then(function(err){throw err})} return r.json()})
    .then(function(){return fetch('/cart.js',{headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})})
    .then(function(r){return r.json()})
    .then(function(cart){render(cart); openCart();})
    .catch(function(err){
      var msg=(err && (err.description||err.message)) || 'Could not add this product to cart.';
      alert(msg);
    })
    .finally(function(){btn.__aceBusy=false;btn.disabled=false;btn.classList.remove('is-adding');btn.innerHTML=old;});
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-ace-direct-add]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    addVariant(btn);
  }, true);
})();
